'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function flatten(data) {
  var result = {};
  var delimiter = '.';

  function recurse(cur) {
    var prop = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      if (!cur.length) result[prop] = [];

      cur.forEach(function (item, i) {
        recurse(cur[i], prop ? [prop, i].join(delimiter) : '' + i);
      });
    } else {
      var isEmpty = true;

      for (var key in cur) {
        if (Object.hasOwnProperty.call(cur, key)) {
          isEmpty = false;
          recurse(cur[key], prop ? [prop, key].join(delimiter) : key);
        }
      }
      if (isEmpty) result[prop] = {};
    }
  }

  recurse(data);

  return result;
}

exports.default = flatten;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-form/lib/utils/flatten.js
 ** module id = 656
 ** module chunks = 0 1
 **/